export default class FACeB2BIdentificatives {
  /** @type {string?} */ DIRE = null
  /** @type {string?} */ Name = null
}
